:host {
  position: relative;
  display: block;

  ::slotted([slot='search-template']) {
    display: none !important;
  }
}

.loader {
  opacity: 0;
  position: fixed;
  block-size: 100%;
  inline-size: 100%;
  min-block-size: 100%;
  max-block-size: 100vh !important;
  max-inline-size: 100vw !important;
  inset-inline-start: 0;
  inset-block-start: 0;
  z-index: -10;
  font-size: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.2s ease, z-index 0.01s ease 0.2s;

  &.loading {
    opacity: 1;
    z-index: 10;
    transition: z-index 0.01s ease, opacity 0.2s ease 0.01s;
  }
}

.default {
  block-size: 100%;

  &:focus {
    outline: none;
  }
}

.results {
  opacity: 0;
  outline: none;
  overflow: auto;
  transition:
    transform 0.3s ease,
    opacity 0.3s ease,
    visibility 0.01s ease 0.3s,
    z-index 0.01s ease 0.3s;
  transform: translate(0, 100px);
  visibility: hidden;
  z-index: -1;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  display: none;

  &-container {
    position: relative;
  }

  &.show {
    transition:
      z-index 0.01s ease,
      visibility 0.01s ease,
      transform 0.3s ease 0.01s,
      opacity 0.3s ease 0.01s;
    transform: translate(0, 0);
    visibility: visible;
    opacity: 1;
    z-index: 10;
    overflow: hidden;
  }

  &.shown {
    block-size: auto !important;
    inline-size: auto !important;
    display: block;
    position: static;
    transform: none;
    z-index: auto;
    visibility: inherit;
    opacity: initial;
  }
}
